import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Currency } from '@emi/shared/models';
import * as Constants from '@emi/shared/constants';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: "root"
})

export class CurrencyService {
  constructor(private httpService : HttpService) { }

  public getCurrencies(): Observable<Currency[]> {
    return this.httpService.getHttp<Currency[]>(Constants.ServiceConstants.COUNTRIES)
  }
}
